/**
 * Activos que habilita Wallet Stablecoins v3 (`feature_wallet_stablecoins_v3`).
 * Las pantallas los reconocen por su código de moneda para ocultarlos cuando la
 * empresa no tiene acceso (ver `useCanAccessWalletStablecoinsV3`).
 */
export const WALLET_STABLECOINS_V3_CURRENCIES: ReadonlySet<string> = new Set(['BTC', 'ETH']);
